var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("img", {
        attrs: {
          src: "/static/icon-error.svg",
          height: "50px",
          alt: "Temos um problema!"
        }
      }),
      _vm._v(" "),
      _c("h2", [_vm._v("AH NÃO... TEMOS UM PROBLEMA!")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n    Olá\n    "),
        _c("b", [_vm._v(_vm._s(_vm.cycle.customer.account.first_name))]),
        _vm._v("\n    ,\n    "),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.reasonText()) } }),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "Entre em contato com nosso atendimento para podermos te ajudar da melhor forma.\n  "
        )
      ]),
      _vm._v(" "),
      _c("whats-app-button", {
        attrs: {
          phone: "5553981134407",
          text: _vm.whatsAppText(),
          label: "Clique aqui para entrar em contato"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-103a2000", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103a2000","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Checkout/CantPayCycle.vue
// module id = null
// module chunks = 